import { render, staticRenderFns } from "./MultipositionHeader.vue?vue&type=template&id=19040fa3&scoped=true"
import script from "./MultipositionHeader.vue?vue&type=script&lang=ts"
export * from "./MultipositionHeader.vue?vue&type=script&lang=ts"
import style0 from "./MultipositionHeader.vue?vue&type=style&index=0&id=19040fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19040fa3",
  null
  
)

export default component.exports